
import React from "react";
import { Clock } from "lucide-react";
import { formatDate } from "@/utils/formatDate";

interface InventoryTimestampProps {
  lastUpdate: string | null;
}

export const InventoryTimestamp: React.FC<InventoryTimestampProps> = ({ lastUpdate }) => {
  if (!lastUpdate) return null;
  
  return (
    <div className="p-3 text-sm text-muted-foreground flex items-center gap-2 border-b">
      <Clock className="h-4 w-4" />
      <span>🕒 Laatste update: {formatDate(lastUpdate)}</span>
    </div>
  );
};
